import { createRootRoute, Outlet } from '@tanstack/react-router';
import { IressSkipLink } from '@iress-oss/ids-components';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { DevToolbar } from '@/components/DevToolbar';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <ErrorBoundary>
      <IressSkipLink href="#main-content" />
      <main id="main-content">
        <Outlet />
      </main>
      {import.meta.env.DEV && <DevToolbar />}
    </ErrorBoundary>
  );
}
